import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { getUserInfo } from '../../services/API';
import config from 'config';

import { actionTypes, requestFailure, requestSuccess } from './actions';
import { startRequest } from '../checkFacetStatus/actions';

function* getInfo(action) {
  const taxpayerInfoResponse = yield call(getUserInfo);
  yield put(
    taxpayerInfoResponse.isOk
      ? requestSuccess(taxpayerInfoResponse.data)
      : requestFailure(taxpayerInfoResponse.error),
  );
  // yield callTaxInfo();

  if (taxpayerInfoResponse.isOk && action.type === actionTypes.GET_INFO) {
    const data = taxpayerInfoResponse.data;
    if (data.dataLastUpdate) {
      const retryNumber = 1;
      yield delay(config.facetCheckingTimeoutInSec * 1000);
      yield put(startRequest(retryNumber));
    }
  }
}

/**
 * Метод api/v1/taxes/taxInfo больше не используется
 * LKFLFNS-59421[Заявление на уточнение налогового уведомления] ЖС недоступна, так как не найден метод api/v1/taxes/taxInfo
 */
// function* callTaxInfo() {
//   const taxInfoResponse = yield call(getTaxInfo);
//   if (!taxInfoResponse.isOk) {
//     yield put(requestFailure(taxInfoResponse.error));
//   } else {
//     const user = yield select((state) => state.app.user);
//     const actualFinesLoaded = user.getIn(['data', 'actualFinesLoaded']);
//     if (taxInfoResponse.data.actualFinesLoaded !== actualFinesLoaded) {
//       yield put(updateTaxInfo(taxInfoResponse.data));
//     }

//     if (!taxInfoResponse.data.actualFinesLoaded) {
//       yield delay(config.finesLoadedCheckingTimeoutInSec * 1000);
//       yield call(callTaxInfo);
//     }
//   }
// }

export default function* userSaga() {
  yield takeLatest(actionTypes.GET_INFO, getInfo);
  yield takeLatest(actionTypes.GET_INFO_SKIP_LOADING, getInfo);
}
